import { featureAvailabilityConfig } from './featureAvailability.config'

const modes = new Set(['hidden', 'comingSoon', 'preview', 'enabled'])
const messages = {
  hidden: 'This feature is not available in this release.',
  comingSoon: 'This feature is being prepared for a future release.',
  preview:
    'This feature is in preview. Only the actions listed as available can be used.',
  enabled: ''
}

export function resolveFeatureAvailability (config, featureId) {
  const entry =
    config && Object.hasOwn(config, featureId) ? config[featureId] : null
  const mode = entry && modes.has(entry.mode) ? entry.mode : 'hidden'
  const canOpen = mode === 'enabled' || mode === 'preview'
  const implemented = Array.isArray(entry?.actions) ? entry.actions : []
  const preview = Array.isArray(entry?.previewActions)
    ? entry.previewActions
    : []
  const actions = canOpen
    ? implemented.filter(
        action =>
          typeof action === 'string' &&
          (mode === 'enabled' || preview.includes(action))
      )
    : []
  return {
    label: entry?.label || 'Feature',
    mode,
    visible: mode !== 'hidden',
    canOpen,
    badge:
      mode === 'preview'
        ? 'Preview'
        : mode === 'comingSoon'
        ? 'Coming soon'
        : null,
    message: entry?.message || messages[mode],
    can: action => actions.includes(action)
  }
}

export function getFeatureAvailability (featureId) {
  return resolveFeatureAvailability(featureAvailabilityConfig, featureId)
}
